// extracted by mini-css-extract-plugin
export default {"fullLabel":"zendeskTickets_fullLabel__6KW3Q","fullInput":"zendeskTickets_fullInput__u4tLB"};